import { useState, useEffect, createContext, useContext } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import AuthPage from "@/pages/AuthPage";
import DashboardPage from "@/pages/DashboardPage";
import TestSetupPage from "@/pages/TestSetupPage";
import UploadTestsPage from "@/pages/UploadTestsPage";
import CorrectionPage from "@/pages/CorrectionPage";
import EvaluationMapPage from "@/pages/EvaluationMapPage";
import ManualPage from "@/pages/ManualPage";
import PrivacyPage from "@/pages/PrivacyPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import ConfirmEmailPage from "@/pages/ConfirmEmailPage";
import AdminPage from "@/pages/AdminPage";
import Layout from "@/components/Layout";
import { api } from "@/lib/api";
import "@/App.css";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("edugrade_token");
    if (token) {
      api.get("/auth/me")
        .then((res) => setUser(res.data))
        .catch(() => localStorage.removeItem("edugrade_token"))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = (token, userData) => {
    localStorage.setItem("edugrade_token", token);
    setUser(userData);
  };

  const logout = () => {
    api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("edugrade_token");
    setUser(null);
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin h-8 w-8 border-4 border-primary border-t-transparent rounded-full" />
      </div>
    );
  }

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/auth" element={!user ? <AuthPage /> : <Navigate to="/dashboard" />} />
          <Route path="/privacidade" element={<PrivacyPage />} />
          <Route path="/repor-password" element={<ResetPasswordPage />} />
          <Route path="/confirmar-email" element={<ConfirmEmailPage />} />
          <Route element={user ? <Layout /> : <Navigate to="/auth" />}>
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/tests/new" element={<TestSetupPage />} />
            <Route path="/tests/:id/upload" element={<UploadTestsPage />} />
            <Route path="/tests/:id/correction" element={<CorrectionPage />} />
            <Route path="/tests/:id/evaluation" element={<EvaluationMapPage />} />
            <Route path="/manual" element={<ManualPage />} />
            <Route path="/admin" element={user?.is_admin ? <AdminPage /> : <Navigate to="/dashboard" />} />
          </Route>
          <Route path="*" element={<Navigate to={user ? "/dashboard" : "/auth"} />} />
        </Routes>
      </BrowserRouter>
    </AuthContext.Provider>
  );
}

export default App;
